import React from 'react'
import { InfoContainer, InfoWrapper, InfoText, InfoHead, InfoP } from './InfoElement'
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor"


const Info2 = () => {
    

   return (
        <InfoContainer> 
            <InfoWrapper>
                <InfoText data-aos="fade-right">
                    <InfoHead><CountUp end={100} duration={5} redraw={true}>
                        {({countUpRef, start}) => (
                            <VisibilitySensor onChange={start} delayedCall>
                                <span ref={countUpRef}/>
                                </VisibilitySensor>
                        )}
                        </CountUp>+</InfoHead>
                    <InfoP>Courses Offered</InfoP>
                </InfoText>

                <InfoText data-aos="fade-right">
                    <InfoHead><CountUp end={120} duration={5} redraw={true}>
                        {({countUpRef, start}) => (
                            <VisibilitySensor onChange={start} delayedCall>
                                <span ref={countUpRef}/>
                                </VisibilitySensor>
                        )}
                        </CountUp>+</InfoHead>
                    <InfoP> Available Tutors</InfoP>
                </InfoText>
                
                <InfoText data-aos="fade-right">
                   <InfoHead><CountUp end={500} duration={5} redraw={true}>
                        {({countUpRef, start}) => (
                            <VisibilitySensor onChange={start} delayedCall>
                                <span ref={countUpRef}/>
                                </VisibilitySensor>
                        )}
                        </CountUp>+</InfoHead>
                    <InfoP>Enrolled Students</InfoP>
                </InfoText>
            </InfoWrapper>
            
        </InfoContainer>
    )
}

export default Info2
